import * as React from "react";
import {ShoppingBasket} from "../../models/ShoppingBasket";
import {ShoppingBasketLineItem } from "../../models/ShoppingBasketLineItem";
import {CartViewerLineItems} from "./CartViewerLineItems";
import {CartLineItem} from "./CartLineItem";
import {CartViewerTotals} from "./CartViewerTotals";
import {Button } from "../common/Button";

export interface CartViewerProp
{
	shoppingBasket: ShoppingBasket;
	removeLineItem: (lineItem: ShoppingBasketLineItem) => void;
	adjustLineItemQty: (lineItem: ShoppingBasketLineItem, qty: number) => void;
	gotoCheckout: () => void;
	allowLineItemEdits: boolean;
	showShipping: boolean;
}

export interface CartViewerState
	{}

export class CartViewer extends React.Component<CartViewerProp, CartViewerState>
{
	render()
	{
		const basket = this.props.shoppingBasket;

		if (basket.lineItems.length === 0)
		{
			return this.shoppingCartEmpty();
		}
		return <div>
			       <div className="shoppingbasket-cartviewer  col-lg-12 col-md-12 col-sm-12 col-xs-12">
				       <CartViewerLineItems shoppingBasket={basket} removeLineItem={this.props.removeLineItem} adjustLineItemQty={
				this.props.adjustLineItemQty} allowLineItemEdits={this.props.allowLineItemEdits}/>
			       </div>
				   <div className="col-lg-12 col-xs-12">
				   	<CartViewerTotals shoppingBasket={basket} showShipping={this.props.showShipping}/>
					</div>
			       <Button label="Proceed to Checkout" onClick={this.props.gotoCheckout}/>
		       </div>;
	}

	private shoppingCartEmpty()
	{
		return <h3>Your Shopping Cart is empty</h3>;
	}
}


// WEBPACK FOOTER //
// ./src/components/shoppingbasket/CartViewer.tsx